import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import {Mensagem} from "./Mensagem";

export const Formulario = () => {
    const [nome, setNome] = useState("");
    const [telefone, setTelefone] = useState("");
    const [email, setEmail] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [status, setStatus] = useState(true);

    const handleSubmit = e => {
        e.preventDefault();
        const data = {
            name: nome,
            email,
            phone: telefone,
            msg: mensagem
        };

        const config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            }
        };
        axios
            .post("/img/enviar.php", data, config)
            .then(res => {
                setStatus(false)
                setTimeout(function(){
                    setStatus(true);
                    setEmail("");
                    setMensagem("");
                    setNome("");
                    setTelefone("");
                }, 3000);

            })
            .catch(err => console.log("err", err));
    };

    return (
        <>

            {status ?
            <form onSubmit={handleSubmit} noValidate autoComplete="off">

                <TextField
                    size={'small'}
                    fullWidth={true}
                    id="name"
                    label="Nome"
                    variant="outlined"
                    style={{margin: "0 10px 10px 0"}}
                    value={nome}
                    onChange={e => setNome(e.target.value)}
                />
                <TextField
                    size={'small'}
                    fullWidth={true}
                    id="phone"
                    label="Telefone"
                    variant="outlined"
                    style={{margin: "0 10px 10px 0"}}
                    value={telefone}
                    onChange={e => setTelefone(e.target.value)}
                />


                <TextField
                    fullWidth={true}
                    size={'small'}
                    type={"email"}
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    style={{margin: "0 10px 10px 0"}}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />


                <TextField
                    id={"msg"}
                    size={'small'}
                    fullWidth={true}
                    placeholder="MultiLine with rows: 2 and rowsMax: 4"
                    multiline
                    rows={3}
                    rowsMax={4}
                    label="Mensagem"
                    variant="outlined"
                    value={mensagem}
                    onChange={e => setMensagem(e.target.value)}
                />

                <div
                    style={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: "20px"
                    }}
                >
                    <Button onClick={handleSubmit}       size={'small'} variant="contained" color="primary">
                        ENVIAR
                    </Button>
                </div>
            </form>
            : <Mensagem/>}
        </>

    );
};

